var map = {
	"./analytics.png": "./src/assets/img/scmp/productType/analytics.png",
	"./compute.png": "./src/assets/img/scmp/productType/compute.png",
	"./container.png": "./src/assets/img/scmp/productType/container.png",
	"./db.png": "./src/assets/img/scmp/productType/db.png",
	"./network.png": "./src/assets/img/scmp/productType/network.png",
	"./storage.png": "./src/assets/img/scmp/productType/storage.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/scmp/productType sync recursive ^\\.\\/.*$";